<template>
    <div>
        <navigation :brand="$route.query.brandName"></navigation>
        <div class="main-wrapper">
            <div class="row">
                <div class="phone-wrapper col-lg-3 col-sm-4 col-xs-12" v-for="(model,i) in models">
                    <router-link v-if="memmoryModels" :to="{name: 'category', query: {model: model.name, brandName: $route.query.brandName}}">
                        <div class="phone">
                            <div class="block-img-wrapper">
                                <img :src="model.img" alt=""> <!--ovde izmeni sliku-->
                            </div>
                            <div class="phone-name">
                                <p>{{model.name}}</p>
                            </div>
                        </div>
                    </router-link>
                    <router-link v-else :to="{name: 'details', query: {model: model.name, brandName: $route.query.brandName}}">
                        <div class="phone">
                            <div class="block-img-wrapper">
                                <img :src="model.img" alt=""> <!--ovde izmeni sliku-->
                            </div>
                            <div class="phone-name">
                                <p>{{model.name}}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from './Navigation'

export default {
  components: {Navigation},
  name: 'phone-models',
  data () {
    return {
      brand: '',
      models: [],
      memmoryModels: false
    }
  },
  methods: {},
  created () {
    this.brand = this.$route.query.brandName
    this.models = this.$root.$data.phonesObject[this.brand].models
    this.memmoryModels = this.$root.$data.phonesObject[this.brand].memmoryModels
  }

}
</script>

<style scoped>

    .phone img{
        max-width: 50%;
    }

</style>
